import React from "react"

// antd
import { Typography, Drawer, Divider } from "antd"
import { ArrowLeftOutlined } from "@ant-design/icons"

// store
// (no language needed)

// i18n
import { useTranslation } from "react-i18next"

// components
import GoogleStaticImage from "./GoogleStaticImage"

// utils
import OrderDescription from "./OrderDescription"

const MenuDrawerOrder = ({ order, onClose, open }) => {
  const { t } = useTranslation()

  return (
    <Drawer
      title={t("my_orders")}
      closeIcon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
      placement="right"
      onClose={onClose}
      open={open}
    >
      {order && (
        <Typography.Title level={4}>
          {t("order_heading", { id: order.id.toUpperCase().slice(0, 4) })}
        </Typography.Title>
      )}

      <Divider />

      {order && <OrderDescription order={order} />}

      {order?.route && (
        <>
          <Divider />
          <GoogleStaticImage route={order.route} />
        </>
      )}
    </Drawer>
  )
}

export default MenuDrawerOrder
